import { BackArrowIcon } from './icons.jsx'
import { BotAvatar } from './Avatars.jsx'

export default function ChatHeader({ onBack, onClear }) {
  return (
    <header className="chat-header">
      <button className="icon-btn back-btn" onClick={onBack} aria-label="Back">
        <BackArrowIcon />
      </button>
      <div className="header-identity">
        <BotAvatar size={44} />
        <span className="header-name">Allie</span>
      </div>
      <button className="clear-btn" onClick={onClear}>
        Clear
      </button>
    </header>
  )
}
